import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';

import { DevicePlateListMaintenanceDto } from './DevicePlateListMaintenanceDto';
import { DevicePlateItemMaintenanceDto } from './DevicePlateItemMaintenanceDto';
@Injectable()
export class DevicePlateSubmaintenanceController extends BaseSubMaintenanceController<DevicePlateListMaintenanceDto, DevicePlateItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {
        super(http, alertService, translateService, loadingService, router, "device/deviceplate");
    }

    public getResourceRoot(): string {
        return "DEVICE.PLATE";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/dataandparameters/device/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}
